<template>
  <div class="progress">
    <utopa-title :title="showData.TITLE.title"
                 :des="showData.TITLE.des">
    </utopa-title>
    <div class="progress-content">
      <img @click.prevent
           :src="showData.IMG1"
           width="100%">
      <h5>
        {{ showData.TITLE.h }}
      </h5>
      <p v-html="showData.TITLE.p"></p>
    </div>
    <utopa-title :title="showData.TITLE2.title">
    </utopa-title>
    <div class="progress-content">
      <img @click.prevent
           :src="showData.IMG2"
           width="100%">
    </div>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import utopaTitle from 'components/title.vue'
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      CN: {
        TITLE: {
          title: '发展规划',
          des: `我们的步伐已迈进<span>4大区域、6大城市</span>，在全国委托管理项目近<span>20个，未来两到三年，发展将辐射全国。</span>
        <br>秉承<span>“共赢+可行性”</span>的发展理念，国内启动<span>“联合拓展-五大战区”</span>的拓展策略；
        <br>实现品牌和项目覆盖<span>粤港澳大湾区和长三角经济圈</span>，全面辐射<span>中国北、中、东、西、南五大区域</span>的商业布局目标；
        <br>重点辐射广州、天津、杭州、武汉、西安等<span>10大核心城市、30个重要城市、</span>发展<span>40个次重要城市</span>据点，全方位构建市场影响力。`,
          h: '国际发展计划',
          p: '现在，优托邦立足中国，放眼全球，通过线上线下互联在伦敦，巴黎，纽约，旧金山和洛杉矶等地高速拓展。'
        },
        TITLE2: {
          title: '企业里程碑'
        },
        IMG1: require('images/progress/1.png'),
        IMG2: require('images/progress/2.png')
      },
      ZH: {
        TITLE: {
          title: '發展規劃',
          des: `我們的步伐已邁進<span>4大區域、6大城市</span>，在全國委託管理項目近<span>20個，未來兩到三年，發展將輻射全國。 </span>
        <br>秉承<span>“共贏+可行性”</span>的發展理念，國內啟動<span>“聯合拓展-五大戰區”</span>的拓展策略；
        <br>實現品牌和項目覆蓋<span>粵港澳大灣區和長三角經濟圈</span>，全面輻射<span>中國北、中、東、西、南五大區域</span>的商業佈局目標；
        <br>重點輻射廣州、天津、杭州、武漢、西安等<span>10大核心城市、30個重要城市、</span>發展<span>40個次重要城市</span>據點，全方位構建市場影響力。`,
          h: '國際發展計劃',
          p: '現在，優托邦立足中國，放眼全球，通過線上線下互聯在倫敦，巴黎，紐約，舊金山和洛杉磯等地高速拓展。'
        },
        TITLE2: {
          title: '企業里程碑'
        },
        IMG1: require('images/progress/1_1.png'),
        IMG2: require('images/progress/2_1.png')
      }
    }
  },
  components: { utopaTitle },
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.progress {
  padding-top: px2rem(54);
  /deep/ .title-p {
    padding: px2rem(12) px2rem(14) 0;
    span {
      color: #3c3c3c;
      font-weight: bold;
    }
  }
  &-content {
    margin: px2rem(20) 0 px2rem(30);
    h5 {
      padding: px2rem(14);
      font-size: px2rem(14);
      color: #3c3c3c;
      font-weight: bold;
    }
    p {
      padding: 0 px2rem(14);
      font-size: px2rem(13);
      color: #666666;
      letter-spacing: 0;
      text-align: justify;
      line-height: px2rem(20);
    }
  }
}
</style>
